export default {
  title: '"Ubuntu", sans-serif',
  text: '"Open Sans", sans-serif',
} as const;
